export default {
    preCheckIn: {
        checkIn: {
            title: 'Registro en línea',
            info: 'Haga clic en el botón Continuar para proceder con el Pre-Check In (Registro Previo)'
        },
        uploadPhoto: {
            title: 'Información Personal',
            formTitle: 'Cargue o capture una foto clara de su identificación emitida por el gobierno',
            formSubtitle: ' (Licencia de conducir, Identificación estatal o Pasaporte)',
            label: 'documento',
            takePhoto: 'Tomar foto',
            takeThisPhoto: 'Usa esta foto',
            reTakePhoto: 'Volver a tomar foto'
        },
        personalInfo: {
            title: 'Información Personal',
            formTitle: 'Verifique su información personal.',
            upload: 'Subir foto',
            change: 'Cambiar foto'
        },
        insuranceData: {
            title: 'Datos del Seguro',
            question: '¿Tiene seguro de salud activo?',
        },
        insuranceCard: {
            title: 'Información del seguro ',
            list: 'la lista de seguros',
            description: {
                primary: ' es un plan de seguro de salud que cubre a una persona como empleado, suscriptor o miembro. El seguro primario se factura primero cuando recibe atención médica. Por ejemplo, el seguro de salud que recibe a través de su empleador suele ser su seguro primario.',
                secondary: ' es un plan de seguro de salud que lo cubre además de su plan de seguro primario. Por lo general, el seguro secundario se factura cuando su plan de seguro primario se agota y puede ayudar a cubrir costos adicionales de atención médica. Por ejemplo, si ya tiene seguro a través de su empleador y elige inscribirse en el plan de seguro de salud de su cónyuge (si se lo permite).',
                tertiary: ' es un plan de seguro de salud que lo cubre además de sus planes de seguro primario y secundario. Por lo general, el seguro terciario se factura cuando se agotan los planes de seguro primario y secundario y puede ayudar a cubrir costos adicionales de atención médica.'
            },
            types: {
                primary: 'Primario',
                secondary: 'Secundario',
                tertiary: 'Terciario',
            },
            confirmSwap: {
                start: 'Por favor, confirme que',
                end: 'es su seguro {type}',
            }
        },
        contactInfo: {
            title: 'Información de Contacto'
        },
        addressInfo: {
            title: 'Dirección',
            formTitle: 'Verificar Dirección'
        },
        emergencyContact: {
            title: 'Contacto de Emergencia',
            formTitle: 'Información de Contacto de Emergencia',
            labels: {
                isMedical: 'Mi contacto de emergencia es mi tomador de decisiones médicas.',
                noEmergency: 'No tengo contacto de emergencia.'
            }
        },
        medicalDecisionMaker: {
            title: 'Tomador de Decisiones Médicas',
            formTitle: 'Información del Tomador de Decisiones Médicas',
            labels: {
                noMaker: 'No tengo tomador de decisiones médicas.'
            }
        },
        primaryCarePhysician: {
            title: 'Médico de Atención Primaria',
            formTitle: 'Información del Médico de Atención Primaria',
            skip: 'No tengo Médico de Atención Primaria'
        },
        referringProvider: {
            title: 'Proveedor de Referencia',
            formTitle: 'Información del Proveedor de Referencia',
            skip: 'No tengo Proveedor de Referencia'
        },
        questionnaire: {
            title: 'Cuestionario',
            data: 'datos del cuestionario'
        },
        signDocuments: {
            title: 'Firmar Documentos',
            formTitle: 'Revise y firme los siguientes documentos para continuar.',
            labels: {
                review: 'Los documentos han sido revisados. Acepte firmar.',
                signature: 'Proporcione su firma',
                doc: 'el documento para previsualizar',
                list: 'la lista de documentos',
                app: 'los datos de la cita',
                insurance: 'el nombre del seguro',
                clinic: 'el nombre de la clínica'
            },
        },
        thankYou: {
            header: 'Gracias',
            title: '¡Gracias por completar el Registro en Línea!',
            formTitle: 'Detalles de la cita',
            info: 'Ha dado el primer paso hacia una mejor salud con USA Pain Clinic.',
            call: 'Si necesita ponerse en contacto con nosotros por cualquier motivo, llame al',
            labels: {
                clinicName: 'los datos de la clínica',
                clinicData: 'el nombre de la clínica'
            },
        },
    },
    components: {
        form: {
            accordionField: {
                defaultText: 'Sin información de seguro',
                initText: 'Por favor, agregue su seguro {type}',
                addText: 'Por favor, agregue primero el seguro {type}',
            },
            insuranceBlock: {
                label: 'tarjeta de seguro',
                imageLabel: 'imagen',
            }
        },
        loginForm: {
            title: 'Proporcione su fecha de nacimiento para iniciar sesión',
            errors: {
                date: 'Por favor, introduzca una fecha válida'
            }
        },
        dobPicker: {
            months: {
                1: 'enero',
                2: 'febrero',
                3: 'marzo',
                4: 'abril',
                5: 'mayo',
                6: 'junio',
                7: 'julio',
                8: 'agosto',
                9: 'septiembre',
                10: 'octubre',
                11: 'noviembre',
                12: 'diciembre'
            },
            labels: {
                day: 'Día',
                month: 'Mes',
                year: 'Año'
            }
        }
    },
    form: {
        preUploader: {
            upload: 'Subir imagen',
            newUpload: 'Subir nueva imagen',
            error: 'No pudimos convertir su foto',
            photoPlaceholder: "Centrar el documento en el marco sobre un fondo oscuro"
        }
    },
    common: {
        errors: {
            fail: '¡Ups, algo salió mal!',
            update: '¡No pudimos actualizar su {type}!',
            get: '¡No se puede obtener {type}!',
            getInfo: '¡No pudimos obtener {type}!',
            save: '¡No pudimos guardar su {type}!',
            saveDoc: '¡No pudimos guardar todos el documento {type}!',
            saveAllDoc: '¡No pudimos guardar todos los documentos!',
            data: '¡No se pueden obtener los datos del usuario!',
            incorrectData: '¡Por favor, ingrese los datos correctos!',
            notRecognize: 'No pudimos reconocer datos del {type}.',
            ocr: '¡Los datos de OCR no se guardaron!',
            photo: '¡La foto de perfil no se guardó!',
            required: 'Requerido',
            doc: '¡No hay documentos para firmar!',
            app: '¡Sin cita previa!',
            signature: 'La firma no puede estar vacía'
        },
        success: {
            photo: '¡La foto de perfil se ha guardado!'
        },
        buttons: {
            next: 'Continuar',
            back: 'Atrás',
            signDoc: 'Firme los documentos',
            clear: 'Limpiar',
            done: 'Listo',
            save: 'Guardar',
            edit: 'Editar',
            cancel: 'Cancelar',
            confirm: 'Confirmar',
            calendar: 'Añadir al calendario',
            setAs: 'Establecer como {type}'
        },
        labels: {
            firstName: 'Nombre',
            lastName: 'Apellido',
            cellPhone: 'Teléfono',
            mobilePhone: 'Teléfono móvil',
            homePhone: 'Teléfono de casa',
            officePhone: 'Teléfono de la oficina',
            fax: 'Fax',
            email: 'Correo electrónico',
            relation: 'Relación',
            dob: 'Fecha de nacimiento',
            address: 'Dirección',
            street1: 'Dirección',
            apartment: 'Apartamento/Número de Suite',
            city: 'Ciudad',
            state: 'Estado',
            zip: 'Postal',
            gender: 'Género (opcional)',
            planCode: 'de Seguro',
            memberId: 'Número de Identificación del Miembro',
            male: 'Masculino ',
            female: 'Femenino',
            yes: 'Sí',
            no: 'No',
            search: 'buscando',
            insurance: {
                name: 'de Seguro',
                company: 'Compañía',
                groupNumber: 'Número de Grupo',
                startDate: 'Fecha de Inicio',
                endDate: 'Fecha de Finalización',
                plan: 'Plan de Salud',
            },
            side: {
                front: {
                    name: 'frontal'
                },
                back: {
                    name: 'trasero'
                },
                title: 'Arrastre y suelte el lado {side} de su {type} aquí o',
                label: 'Lado {side} de su {type}'
            },
            relations: {
                'Child': 'Niño',
                'Spouse': 'Cónyuge',
                'Wife': 'Esposa',
                'Husband': 'Marido',
                'Parent': 'Padre',
                'Self': 'Yo',
                'Special Dependent': 'Dependiente Especial',
                'Employee': 'Empleado',
                'Grandparent': 'Abuelo',
                'Aunt': 'Tía',
                'Uncle': 'Tío',
                'Grandchild': 'Nieto',
                'Niece/Nephew': 'Sobrina sobrino',
                'Organ Donor': 'Donante de órganos',
                'Cadaver Donor': 'Donante de cadáveres',
                'Life Partner': 'Compañero de vida',
                'Other': 'Otro'
            }
        },
        rules: {
            valid: 'Por favor, ingrese un {field}',
            emptyPhoto: 'Por favor, cargue la imagen del lado {side}'
        }
    }
}
